// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isProductQuoteRequired } from "@awc/App/Store/Selectors/ProductSelectors";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button/Button";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC, useState } from "react";

interface OwnProps {
    extendedStyles?: ProductQuoteButtonStyles["button"];
}

type Props = OwnProps & HasProductContext;

interface ProductQuoteButtonStyles {
    button?: ButtonPresentationProps;
}

export const productQuoteButtonStyles: ProductQuoteButtonStyles = {};

const ProductQuoteButton: FC<Props> = ({ productContext: { product, productInfo }, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(productQuoteButtonStyles.button, extendedStyles));
    const history = useHistory();
    if (!isProductQuoteRequired(product, productInfo)) {
        return null;
    }

    const onClickHandler = () => {
        history.push(product.canonicalUrl);
    };

    return (
        <Button {...styles} onClick={onClickHandler} data-test-selector="ProductQuoteButton">
            {translate("CLICK FOR QUOTE")}
        </Button>
    );
};

export default withProductContext(ProductQuoteButton);
